import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { convertTextToEmojiHtml } from "@/common/emojis";
import { linkifyHrefInText } from "../../utils";
export default function ChatTextMessageItem(props) {
  var html = convertTextToEmojiHtml(linkifyHrefInText(props.message.text));
  var r = html.replace(/\r\n|\r|\n/g, "<br />");
  return _jsx("p", {
    dangerouslySetInnerHTML: {
      __html: r
    }
  }, void 0);
}